import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import View from './views/View.vue'
import View2 from './views/View2.vue'
import Preview from './views/Preview.vue'
import Preview2 from './views/Preview2.vue'
import Rubric from './views/Rubric2.vue'
import Contact from './views/Contact.vue'
import Privacy from './views/Privacy.vue'
Vue.use(Router)

export default new Router({
  mode: 'history',
  fallback:false,

  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
      {
    	path: '/comebacker',
		name: 'comebacker',
    	component: Home
    },
    {
    	path: '/back',
    	name: 'back',
    	component: Home
    },
    {
      path: '/rubric_:rubricId',
      name: 'home_rubric',
      component: Home,
      props: { default: true}
    },
    {
      path: '/rubric/rubric_:rubricId',
      name: 'rubric',
      component: Rubric
    },
    {
      path: '/preview/new',
      name: 'preview',
      component: Preview
    },
      {
          path: '/preview2/new',
          name: 'preview2',
          component: Preview2
      },
    {
      path: '/view/new',
      name: 'view',
      component: View
    },
      {
          path: '/view2/new',
          name: 'view2',
          component: View2
      },
//       {
//           path: '/contact',
//           name: 'contact',
//           component: Contact
//       },
//       {
//           path: '/privacy',
//           name: 'privacy',
//           component: Privacy
//       }
  ]
})